/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import React from 'react'
import { Modal, ModalBody, Button, ModalHeader } from 'reactstrap';
import SDGIcon from '@g17eco/molecules/sdg-icon/sdg-icon';
import { getSDGShortTitle } from '../../../constants/sdg-data';

export interface SDGContribution {
    oldValue?: number,
    universalTracker: {
        code: string
    }
    value: number
}

interface SDGContributionModalProps {
    isOpen: boolean;
    toggle: () => void;
    sdgContribution: SDGContribution;
}


const SDGContributionModal = (props: SDGContributionModalProps) => {
    const { isOpen, toggle, sdgContribution } = props;

    const newValue = Math.round(sdgContribution.value)
    const percentageIncreased = newValue - Math.round(sdgContribution.oldValue ?? 0)

    const sdgCode = sdgContribution.universalTracker.code.replace('sdg/', '')
    const int = parseFloat(sdgCode) % 1 === 0;

    return <Modal isOpen={isOpen} toggle={toggle} backdrop='static'>
        <ModalHeader toggle={toggle}><br/></ModalHeader>
        <ModalBody>
            <div className='p-3 pl-5'>
                <h1 className='mb-3'>Amazing!</h1>
                <div className='d-flex'>
                    <SDGIcon code={sdgCode} width={70} height={70} />
                    <p className='ml-3'>Your contribution to
                    <br />
                        <span><b>{`${int ? 'SDG' : 'Target'} ${sdgCode}: ${getSDGShortTitle(sdgCode)}`}</b></span>
                        <br />
                        <span>just increased by</span></p>
                </div>
                <div className='text-center text-ThemeSuccessMedium' style={{ fontSize: '40px' }}>{`${percentageIncreased}%`}</div>
                <div className='d-flex justify-content-end pr-3 mt-3'>
                    <Button onClick={toggle}>Dismiss</Button>
                </div>
            </div>
        </ModalBody>
    </Modal>
}

export default SDGContributionModal;
